import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdvanceCreditorBalanceApi } from "../../../apiservice/reports";

export const fetchAdvanceCreditors = createAsyncThunk(
  "advanceCreditor/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const reqPayload = {
        locationId: filters.locationId,
        accId: filters.creditorId,
      };

      const res = await getAdvanceCreditorBalanceApi(reqPayload);
      
      if (res === "Error: Request failed with status code 401") {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }

      return res.data.accounts || [];

    } catch (err) {
      console.error("Error fetching advance creditor data:", err);
      
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }
      
      return rejectWithValue(
        err.response?.data?.message || 
        err.message || 
        "Failed to fetch advance creditor data"
      );
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All Creditor",
    creditorId: null,
    locationId: null,
  },
  totals: {
    received: 0,
    payment: 0,
    balance: 0,
  },
};

const advanceCreditorSlice = createSlice({
  name: "advanceCreditor",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetData: (state) => {
      state.list = [];
      state.totals = { received: 0, payment: 0, balance: 0 };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvanceCreditors.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdvanceCreditors.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        
        // Calculate totals
        state.totals = action.payload.reduce((acc, curr) => ({
          received: acc.received + parseFloat(curr.rcv_amount || 0),
          payment: acc.payment + parseFloat(curr.pay_amount || 0),
          balance: acc.balance + parseFloat(curr.balance || 0),
        }), { received: 0, payment: 0, balance: 0 });
      })
      .addCase(fetchAdvanceCreditors.rejected, (state) => {
        state.loading = false;
        state.list = [];
        state.totals = { received: 0, payment: 0, balance: 0 };
      });
  },
});

export const { setFilters, resetData } = advanceCreditorSlice.actions;
export default advanceCreditorSlice.reducer;